import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Sofía — Córdoba',
  initials: 'S',
  text: 'Me encantaron las plantillas. Imprimí varias y pude empezar sin tener que diseñar todo desde cero.'
}, {
  name: 'Mariana — Buenos Aires',
  initials: 'M',
  text: 'Compré el Mega Kit de $24.990 e hice souvenirs para un bautismo. Me salieron re lindos y ya me pidieron más.'
}, {
  name: 'Camila — Rosario',
  initials: 'C',
  text: 'Me pareció un emprendimiento súper original. Por mi zona casi nadie hace tricotín y eso llama mucho la atención.'
}, {
  name: 'Florencia — Mendoza',
  initials: 'F',
  text: 'Está todo muy claro. Las plantillas y los videos me ayudaron a animarme aunque nunca había hecho tricotín.'
}, {
  name: 'Luciana — La Plata',
  initials: 'L',
  text: 'Lo compré para probar algo distinto y terminé haciendo llaveros y lapiceras para vender. Me encantó.'
}, {
  name: 'Agustina — Santa Fe',
  initials: 'A',
  text: 'Antes tenía mil ideas guardadas y nunca arrancaba. Con las plantillas pude hacer mis primeras piezas prolijas.'
}];
function TestimonialContent({
  testimonial,
  visible = true
}: {
  testimonial: (typeof testimonials)[number];
  visible?: boolean;
}) {
  return <div className={`bg-brand-card p-6 sm:p-12 rounded-[2rem] sm:rounded-[3rem] shadow-md border border-brand-warm flex flex-col justify-center items-center text-center ${!visible ? 'invisible' : ''}`} data-id="element-174">
      <div className="flex gap-1 mb-4 sm:mb-6" data-id="element-175">
        {[...Array(5)].map((_, j) => <Star key={j} className="text-brand-bonus fill-brand-bonus w-5 h-5 sm:w-6 sm:h-6" data-id="element-176" />)}
      </div>
      <p className="text-base sm:text-xl md:text-2xl text-brand-text/90 leading-relaxed mb-6 sm:mb-8 font-normal italic px-2 sm:px-6" data-id="element-177">
        "{testimonial.text}"
      </p>
      <p className="font-serif font-bold text-brand-text text-lg sm:text-xl" data-id="element-178">
        {testimonial.name}
      </p>
    </div>;
}
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  useEffect(() => {
    const timer = setInterval(nextTestimonial, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-179">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12 px-2" data-id="element-180">
        <h2 className="text-2xl sm:text-4xl lg:text-5xl text-brand-text mb-3 sm:mb-4 font-bold leading-tight" data-id="element-181">
          Lo que dicen nuestras clientas
        </h2>
        <p className="text-sm sm:text-lg text-brand-text/80 font-sans font-medium italic" data-id="element-182">
          Experiencias reales de mujeres que se animaron a empezar
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto px-1 sm:px-12" data-id="element-183">
        <div className="relative" data-id="element-184">
          <div aria-hidden="true" className="invisible" data-id="element-185">
            <TestimonialContent testimonial={testimonials[currentIndex]} visible={false} data-id="element-186" />
          </div>

          <div className="absolute inset-0" data-id="element-187">
            <AnimatePresence mode="wait" data-id="element-188">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.4
            }} className="h-full" data-id="element-189">
                <TestimonialContent testimonial={testimonials[currentIndex]} data-id="element-190" />
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 sm:p-4 rounded-full shadow-md border border-brand-warm text-brand-text hover:text-brand-cta transition-colors z-10 -ml-2 sm:ml-0" aria-label="Previous testimonial" data-id="element-191">
          <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-192" />
        </button>
        <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 sm:p-4 rounded-full shadow-md border border-brand-warm text-brand-text hover:text-brand-cta transition-colors z-10 -mr-2 sm:mr-0" aria-label="Next testimonial" data-id="element-193">
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-194" />
        </button>

        <div className="flex justify-center gap-3 mt-6 sm:mt-8" data-id="element-195">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-brand-cta w-8 sm:w-10' : 'bg-brand-warm hover:bg-brand-pink'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-196" />)}
        </div>
      </div>
    </section>;
}